module.exports = __webpack_public_path__ + "img/par_21.7cf83237.jpg";